import React, { Component } from "react";
import EditDivisionDialog from "../../components/teams/EditDivisionDialog";
import { languages } from "../../constants/languages";
import moment from "moment-timezone";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import Typography from "@material-ui/core/Typography";
import CreateIcon from "@material-ui/icons/Create";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import { getUploadErrorMessage } from "../../util/uploadErrors";

const StyledAvatar = withStyles({
  img: {
    height: "unset",
    borderRadius: 4,
  },
})(Avatar);

class EditDivisionContainer extends Component {
  state = {
    open: false,
    name: "",
    submitDisabled: true,

    sponsorName: "",
    sponsorLogoURL: "",
    isUploading: false,
    errorMessageSponsor: "",
    showSponsor: false,
    newSponsorLogo: false,
  };

  handleShowSponsorChange = (event, checked) => {
    let newState = { submitDisabled: false };
    newState[event.target.name] = checked;
    this.setState(newState);
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  UNSAFE_componentWillMount = () => {
    const division = this.props.division;
    if (division) {
      this.updateState(division);
    }
  };

  updateState = (division) => {
    this.setState({
      name: division.name || "",
      showSponsor: division.showSponsor || false,
      sponsorName: division.sponsorName || "",
      sponsorLogoURL: division.sponsorLogoURL || "",
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.props.division) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    this.toggleDialog();
    const divisionsRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("divisions");

    let division = {};
    let divisionId = moment().unix().toString();
    let divisionDoc = divisionsRef.doc(divisionId);
    if (this.props.division) {
      division = this.props.division;
      divisionId = this.props.division.id;
      divisionDoc = divisionsRef.doc(this.props.division.id);
    }

    // division changes
    division["name"] = this.state.name;
    division["sponsorName"] = this.state.sponsorName;
    division["sponsorLogoURL"] = this.state.sponsorLogoURL;
    division["showSponsor"] = this.state.showSponsor;

    divisionDoc
      .set(division)
      .then(() => {
        if (this.props.division) {
          this.setState({ submitDisabled: true });
        } else {
          if (window.firebase.analytics) {
            window.firebase.analytics().logEvent("division_added");
          }
          this.setState({
            submitDisabled: true,
            name: "",
          });
        }
        if (this.state.sponsorLogoURL && this.state.newSponsorLogo) {
          var httpsReference = window.firebase
            .app()
            .storage("gs://tournament-uploads/")
            .refFromURL(this.state.sponsorLogoURL);
          httpsReference
            .updateMetadata({
              customMetadata: {
                sponsorType: "divisions",
                tournamentId: this.props.tournament[".key"],
                elementId: divisionId,
              },
            })
            .catch(function (error) {
              // Uh-oh, an error occurred!
              console.log(error.message);
            });
        }
      })
      .catch((error) => {
        this.setState({ submitDisabled: false });
      });
  };

  handleDeleteSponsor = () => {
    let toUpdate = {
      sponsorLogoURL: "",
      newSponsorLogo: false,
      submitDisabled: false,
    };
    this.setState(toUpdate);
    // let urlToDelete = this.state.sponsorLogoURL;

    // window.firebase
    //   .firestore()
    //   .collection("tournaments")
    //   .doc(this.props.tournament[".key"])
    //   .collection("divisions")
    //   .doc(this.props.division.id)
    //   .update(toUpdate);

    // var httpsReference = window.firebase
    //   .app()
    //   .storage("gs://tournament-uploads/")
    //   .refFromURL(urlToDelete);
    // httpsReference.delete().catch(function (error) {
    //   // Uh-oh, an error occurred!
    //   console.log(error.message);
    // });
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "sponsors/" + this.props.user.uid + "/" + this.props.tournament[".key"]
      );
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessageSponsor: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    let toUpdate = { errorMessageSponsor: getUploadErrorMessage(error, 1) };
    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename) => {
    this.setState({ isUploading: false });
    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        let toUpdate = {
          sponsorLogoURL: url,
          submitDisabled: false,
          newSponsorLogo: true,
        };
        this.setState(toUpdate);
        // window.firebase
        //   .firestore()
        //   .collection("tournaments")
        //   .doc(this.props.tournament[".key"])
        //   .collection("sportParks")
        //   .doc(this.props.sportPark.id)
        //   .update(toUpdate);
      });
  };

  render() {
    let allowedToUpload = false;
    if (
      (this.props.tournamentStatus || {}).status === 1 ||
      (this.props.tournamentStatus || {}).status === 2 ||
      (this.props.tournamentStatus || {}).status === 3 ||
      (this.props.userStatus || {}).status === 1 ||
      (this.props.userStatus || {}).status === 2 ||
      (this.props.userStatus || {}).status === 3
    ) {
      allowedToUpload = true;
    }

    return (
      <div>
        {this.props.division ? (
          this.props.new ? (
            <TextField
              style={{ marginTop: 10, marginBottom: 5 }}
              onClick={this.toggleDialog}
              value={this.props.division.name}
              fullWidth
              label={languages.divisions.division + " " + this.props.num}
            />
          ) : (
            // <ExpansionPanel
            //   expanded={false}
            //   style={{
            //     width: "100%",
            //     margin: "1px 0px 1px 0px",
            //   }}
            // >
            //   <ExpansionPanelSummary
            //     IconButtonProps={{ onClick: this.toggleDialog }}
            //     expandIcon={<CreateIcon />}
            //     style={{ cursor: "inherit" }}
            //   >
            //     <Typography
            //       variant="body2"
            //       style={{
            //         flexBasis: "33.33%",
            //         flexShrink: 0,
            //         color: "rgba(0, 0, 0, 0.54)",
            //       }}
            //     >
            //       {languages.divisions.division + " " + this.props.num}
            //     </Typography>
            //     <Typography variant="body2">
            //       {this.props.division.name}
            //     </Typography>
            //   </ExpansionPanelSummary>
            // </ExpansionPanel>

            <Card style={{ marginBottom: 1 }}>
              <CardHeader
                style={{ padding: "5px 15px" }}
                avatar={
                  <StyledAvatar
                    variant="rounded"
                    style={{
                      fontWeight: 500,
                      backgroundColor:
                        this.props.division.sponsorLogoURL &&
                        this.props.division.showSponsor
                          ? "white"
                          : (this.props.color || {}).background || "",
                      color: (this.props.color || {}).color || "",
                    }}
                    aria-label="division-number"
                    src={
                      this.props.division.sponsorLogoURL &&
                      this.props.division.showSponsor
                        ? this.props.division.sponsorLogoURL
                        : ""
                    }
                  >
                    {this.props.division.sponsorLogoURL &&
                    this.props.division.showSponsor
                      ? ""
                      : this.props.num}
                  </StyledAvatar>
                }
                action={
                  <IconButton
                    aria-label="edit-division"
                    onClick={this.toggleDialog}
                    style={{ marginTop: 8 }}
                  >
                    <CreateIcon />
                  </IconButton>
                }
                title={
                  this.props.division.name +
                  (this.props.division.sponsorName &&
                  this.props.division.showSponsor
                    ? " - " + this.props.division.sponsorName
                    : "")
                }
              />
            </Card>
          )
        ) : this.props.new ? (
          <Button
            style={{ marginTop: 10 }}
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
          >
            {languages.createTournament.addDivision}
          </Button>
        ) : (
          <Button
            style={{ height: 48 }}
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
            fullWidth
          >
            {languages.divisions.addDivision}
          </Button>
        )}
        <EditDivisionDialog
          name={this.state.name}
          submitDisabled={this.state.submitDisabled}
          tournament={this.props.tournament}
          open={this.state.open}
          division={this.props.division}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          selectDivision={this.props.selectDivision}
          selectedDivision={this.props.selectedDivision}
          // sponsor
          sponsorName={this.state.sponsorName}
          sponsorLogoURL={this.state.sponsorLogoURL}
          sponsorStorageRef={this.getStorageRef()}
          handleDeleteSponsor={this.handleDeleteSponsor}
          handleUploadStart={this.handleUploadStart}
          handleProgress={this.handleProgress}
          handleUploadError={this.handleUploadError}
          handleUploadSuccess={this.handleUploadSuccess}
          allowedToUpload={allowedToUpload}
          new={this.props.new}
          handleShowSponsorChange={this.handleShowSponsorChange}
          showSponsor={this.state.showSponsor}
          toggleUpgradeDialog={this.props.toggleUpgradeDialog}
          errorMessageSponsor={this.state.errorMessageSponsor}
          isUploadingSponsor={this.state.isUploading}
        />
      </div>
    );
  }
}

export default EditDivisionContainer;
